import { Card, CardBody, Button, Container, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { LOGIN } from "../../services/actions";
import { Warning } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";

export default function Warnings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userState = useSelector((state) => state?.login);
  const { handleSubmit } = useForm({
    defaultValues: { "username": "admin@gmail.com", password: "Admin@123" },
    mode: "all"
  });

  return (
    <>
      <Container fluid className="g-0 mt-4">
        <Row className="d-flex justify-content-center g-0">
          <Col xs={12} sm={8} md={5} xl={4}>
            <Card style={{ minWidth: 210, border: "none" }}>
              <CardBody className="px-4">
                <h1 className="d-flex mb-5 justify-content-center">Payment Portal</h1>
                <form 
                  autoComplete="off" 
                  onSubmit={handleSubmit((data) => {
                    console.log("FORM", data);
                    dispatch({ type: `${LOGIN}_AUTH`, payload: data });
                  })}
                >
                  <div className="text-center text-danger my-4">
                    <Warning fontSize={80} />
                    <div className="my-3">
                      This Mobile Number is not registered with us, or you do not have an active account.
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-4 pt-4">
                    <Button 
                      variant="outline-primary" 
                      size="lg" 
                      className="px-4" 
                      onClick={() => navigate("/")}
                    >
                      Back
                    </Button>
                  </div>
                </form>
                {userState?.message && (
                  <div className="error text-center mt-3">{userState?.message}</div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
